import React, { Component, PropTypes } from 'react';
import baseUrl from  '../../../utils/baseUrl';

import Form from '../../form/form';
import InputRange from '../../form/range/range';
import InputText from '../../form/input/text';
import InputSwitch from '../../form/input/switch';
import InputTextarea from '../../form/input/textarea';
import InputSubmit from '../../form/input/submit';

export default class JuryVoteFOTX extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		waiting: PropTypes.bool,
		selected: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.oneOf([false]),
		]),
		path: PropTypes.string.isRequired,
		onSubmit: PropTypes.func.isRequired,
		onChangeVote: PropTypes.func.isRequired,
	};

	static defaultProps = {
		waiting: false,
		selected: false,
		onSubmit: function(promise) {},
		onChangeVote: function(res) {},
	};

	constructor(props) {
		super();

		this.state = {
			selected: props.selected,
			showWarning: false,
			notBroken: false,
			value: !!(props.item.id === props.selected),
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.selected !== nextProps.selected) {
			this.setState({
				...this.state,
				value: !!(nextProps.item.id === nextProps.selected),
			});
		}
	}

	render() {
		let className = 'span14-tablet span14-mobile account-jury__entry__col3 account-jury__entry__votation';
		let item = this.props.item;

		return (
			<div className={className}>
				<Form getRefs={() => this.getRefs()} disableErrors method='post' action={this.props.path} onSubmit={this.onSubmit.bind(this)} disableAjaxSubmit>
					<InputText name='id' ref='id' type='hidden' value={item.id} />

					<div className='account-jury__entry__votation__top'>
						<div className='account-jury__entry__votation__top__switch'>
							<InputSwitch name='win' on='Yes' off='No' value={this.state.value} allowToggleOff={false} onChange={this.onChangeVote.bind(this)}/>
						</div>
					</div>

					<div className='account-jury__entry__votation__bottom '>
						<div className='account-jury__entry__votation__comment'>
							<InputTextarea
								name='comment'
								ref='comment'
								placeholder='Any comments or messages for Rob?'
								className='account-jury__entry__votation__comment__textarea account-jury__entry__votation__comment__textarea--fill'
								span='span100p'
								value={(this.props.data) ? this.props.data.comment : ''}
							/>

							<div className='account-jury__entry__votation__comment__vote'>
								<div className="account-jury__entry__votation__comment__vote__flex">
									<InputSubmit name='Submit your vote' value='Submit your vote' waiting={(this.props.waiting === item.id)} className='button--light' />
								</div>
							</div>
						</div>
					</div>
				</Form>
			</div>
		);
	}

	getRefs() {
		return this.refs;
	}

	onSubmit(promise) {
		this.setState({ ...this.state });
		this.props.onSubmit(
			new Promise((resolve, reject) => {
				promise.then((res) => {
					this.setState({ ...this.state });
					resolve(res);
				}).catch((res) => {
					this.setState({ ...this.state });
					reject(res);
				});
			})
		);
	}

	onChangeVote(val) {
		this.setState({
			...this.state,
			value: val,
		});

		this.props.onChangeVote({
			id: this.props.item.id,
			value: val,
		});
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/juryVoteFOTX.js
 **/